export default __webpack_public_path__ + "static/media/016-flood.6f1ff5a3.svg";